
document.addEventListener('turbolinks:load',function(){
  document.querySelectorAll(".articles-slider").forEach((e,i)=>{
    M.Carousel.init(e,{
      fullWidth: true,
      indicators: true
    });
  });
})
